import React from 'react'

const GlobalLoading = () => {
    return (
        <>
            <span className="loading d-flex align-items-center justify-content-center"
                style={{ height: 200 }}>
                <i className="ri-loader-2-fill fs-25 rotation"></i>
            </span>
        </>
    )
}

export default GlobalLoading